app.directive('productCustomerReview', [
  '$http',
  'product',
  'featureService',
  'staticImageHost',
  function ($http, product, featureService, staticImageHost) {
    return {
      templateUrl:
        '/themes/shared/product/templates.product_customer_review.html',
      restrict: 'E',
      scope: false,
      link: function (scope) {
        var amazonAsin = product.amazon_asin;
        if (
          !amazonAsin ||
          !featureService.hasFeature('amazon_product_review')
        ) {
          return;
        }
        scope.showMoreUrl =
          'https://www.amazon.com/product-reviews/' + amazonAsin;
        var pagination = {
          currentPage: 1,
          limit: 10,
        };

        var fetchProductReviews = function () {
          $http
            .get('/api/amazon_products/' + amazonAsin + '/reviews', {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
              params: {
                page: pagination.currentPage,
                limit: pagination.limit,
              },
            })
            .then(function (res) {
              scope.reviewData = res.data;
              scope.amazonProductReview = res.data.amazon_product;
            })
            .catch(function () {
              scope.reviewData = null;
              scope.amazonProductReview = null;
            });
        };

        scope.staticImageHost = staticImageHost;

        fetchProductReviews();
      },
    };
  },
]);
